import React from 'react';

import classNames from 'classnames';
import { connect } from 'react-redux';

import { useActiveTheme } from '@/hooks/useActiveTheme';
import { useTranslation } from '@/i18n';
import { AmbassadorProfile } from '@/models/authModels';
import { ServerStatus } from '@/models/globalModels';
import { RootState } from '@/redux/rootReducer';

import AmbaImage from './AmbaImage';

const mapStateToProps = (state: RootState) => {
  const auth = state.auth;
  return {
    profile: auth.ambassadorProfile,
    ambassadorStatus: auth.ambassadorStatus,
  };
};

const ReferredBy = ({
  profile,
  ambassadorStatus = ServerStatus.IDLE,
}: {
  profile?: AmbassadorProfile;
  ambassadorStatus?: ServerStatus;
}) => {
  const { t } = useTranslation('dashboard');
  const [showReferredBy, setShowReferredBy] = React.useState(false);
  const referredBy = profile?.referred_by;
  const defaultAvatarImg = '/images/generic_avatar.png';
  const { theme } = useActiveTheme();

  React.useEffect(() => {
    if (ambassadorStatus === ServerStatus.FETCH && referredBy) {
      setShowReferredBy(true);
    }
  }, [ambassadorStatus, referredBy]);

  return (
    <>
      {showReferredBy ? (
        <div className="referredBy align-items-center justify-content-center row">
          <div className="mt-2">
            <h3 className="f-14 f-raleway-bold">{t('sidebar.referredBy')}</h3>
          </div>
          <div className="mt-2 col-12 col-sm-6 w-100 d-block">
            <div className="container w-100 d-flex align-items-center justify-content-center">
              <AmbaImage
                alt="user profile image"
                extraClass="referredAvatar m-auto me-1"
                fallbackSrc={defaultAvatarImg}
                imageSrc={referredBy?.avatar_url}
                isLink={false}
              />
              <span className="icon-bubbles3 f-20 me-1" />
            </div>
            <div className="container m-0 p-0 w-100 overflow-hidden text-center d-block">
              <span className={classNames('f-14 f-raleway-regular', theme === 'dark' && 'c-mercury', theme === 'light' && 'c-pickled')}>
                {referredBy?.name}
              </span>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default connect(mapStateToProps)(ReferredBy);
